<template>
  <history-list :entity-id="orderId" :entity-type-id="ENTITY_TYPE.ORDER" />
</template>

<script lang="ts">
import HistoryList from '@/components/history/HistoryList.vue'
import { useOrder } from '../order'
import { ENTITY_TYPE } from '@/utils/constants'

export default {
  name: 'History',
  components: { HistoryList },
  setup() {
    const { orderId } = useOrder()

    return { ENTITY_TYPE, orderId }
  },
}
</script>
